import SAPOMailConfig    from '@/SAPOMailConfig';
import FolderItem        from "../Entities/FolderItem";
import FoldersData       from "../Entities/FoldersData";

export { FoldersHTTPMapping as default };

/**
* Handles All Folder Messages Data
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FoldersHTTPMapping {
  /**
   * Maps Folder data
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FoldersData} folders
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapFolders(folders, results) {
    if (results.d) {
        results.d.forEach(folder_id => {
          this.deleteFolderFromCollection(
            folders,
            folder_id
          );
      });
    }

    if (results.a) {
        results.a.forEach(folder => {
          this.addFolderToCollection(
            folders,
            this.mapFolderItem(folder, new FolderItem())
          );
      });
    }

    if (results.c) {
        results.c.forEach(folder => {
        this.mapFolderItem(
          folder,
          folders.all.get(folder.m),
        )
      });
    }

    if (results.switch) {
      folders.folder_switch = folders.all.get(results.switch);
    }

    this.resortFolders(folders);
  }

  /**
   * Maps a new folder Item into given data
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object}     data   folder data
   * @param {FolderItem} folder folder item
   *
   * @return {FolderItem}
   */
  mapFolderItem(data, folder) {
    folder.id      = data.m;
    folder.name    = data.l;
    folder.level   = 1;
    folder.main    = (SAPOMailConfig.client.folders.main[data.m]) ? true : false;
    folder.parent  = data.pa || null;
    folder.icon    = SAPOMailConfig.client.folders.icons[folder.id] || SAPOMailConfig.client.folders.icons.default;


    if (data.t) {
      let split    = data.t.split('.')
      folder.level = split.length;
      folder.imap  = data.t;
      folder.path  = '/' + split.join('/');
    } else {
      folder.imap  = SAPOMailConfig.client.folders.imap_name[folder.id] || folder.name;
      folder.path  = '/' + folder.name;
    }

    return folder;
  }


  /**
   * Updates folder unread count in the folder index
   *
   * This method is invoked by the MailBoxModel once it retrieves data from the serve
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FoldersData} folders
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapFoldersPoll(folders, results) {
    for (let folder_id in results) {
      let folder    = folders.all.get(folder_id);
      folder.unread = results[folder_id];
    }

    folders.custom.recalculateUnread();
    folders.main.recalculateUnread();
    folders.all.recalculateUnread();
    folders.all.recalculateChildsUnread();
  }

  /**
   * Adds folder items to the corresponding collections
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FoldersData} folders
   * @param {FolderItem}  folder
   *
   * @return {FolderItem}
   */
  addFolderToCollection(folders, folder) {
    folders.all.add(folder);

    if (SAPOMailConfig.client.folders.main[folder.id] || folders.main.index[folder.parent]) {4
      folder.main = true;
      folders.main.add(folder);
      return;
    }

    folders.custom.add(folder);
  }

  /**
   * Deletes folders from all collections
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FoldersData} folders
   * @param {String}      folder_id
   *
   * @return {FolderItem}
   */
  deleteFolderFromCollection(folders, folder_id) {
    folders.all.delete(folder_id);
    folders.custom.delete(folder_id);
    folders.main.delete(folder_id);
  }

  /**
   * Resets folders
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FoldersData} folders
   *
   * @return {FolderItem}
   */
  resetFolders(folders) {
    folders.all.reset();
    folders.custom.reset();
    folders.main.reset();
  }

  /**
   * Resorts all list items
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FolderItem}  folder
   *
   * @return {void}
   */
  resortFolders(folders) {
    folders.custom.resortItems();
    folders.main.resortItems();
    folders.all.resortItems();
  }
}